export default __webpack_public_path__ + "static/media/mcl.fd6560d7.jpg";